import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Testimonials.css';

const LONG_TEXT_THRESHOLD = 320;

/**
 * Composant Testimonials - Section des témoignages clients
 */
function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  const founderLink = (
    <Link to="/#fondateur" className="testimonial-founder-link">
      Jonathan KONDE
    </Link>
  );

  const testimonials = [
    {
      id: 1,
      name: 'MABASI MITUNGA Dorcas',
      role: 'Étudiante en Informatique Industrielle - ISPT Likasi',
      project: 'TFE - Système automatique de pointage RFID',
      content:
        'Je tiens à exprimer ma profonde reconnaissance à mon professeur, éminent spécialiste en informatique, pour son accompagnement précieux dans la conception de mon application intitulée « Conception d\'un système automatique de pointage des agents au sein de la mairie de Likasi avec la technologie RFID ». Par son expertise, sa rigueur scientifique et son engagement constant, il a su éclairer chaque étape de ce travail. Je lui rends hommage pour ses efforts inlassables et pour l\'excellence qu\'il incarne, ayant contribué de manière déterminante à la réussite de ce projet.',
      rating: 5,
      image: '/temoin1.png',
    },
    {
      id: 2,
      name: 'MBIYA NGOIE David',
      role: 'Étudiant en Informatique (L4) - UPC Kinshasa',
      project: 'Mémoire - Application d\'analyse de données urbaines',
      content:
        'Wote m\'a accompagné tout au long de la rédaction de mon mémoire. Leur expertise, leur disponibilité et la qualité de leur soutien ont joué un rôle déterminant dans l\'aboutissement de mon travail. Grâce à leur accompagnement, j\'ai pu avancer avec confiance et sérénité. Je recommande sincèrement leurs services à toute personne souhaitant réussir son projet.',
      rating: 5,
      image: '/temoin2.png',
    },
    {
      id: 3,
      name: 'Alex Tshibangu',
      role: 'Coach de vie, Conférencier, Formateur de leaders et Conducteur de louange',
      project: 'Site web AltCoach — www.altcoach.org',
      content: (
        <p className="testimonial-text-block">
          Il est des collaborateurs dont la contribution dépasse largement le cadre professionnel.{' '}
          {founderLink} en est un exemple éclatant. Il est ce couteau suisse qui a travaillé dans
          l&apos;ombre pour la conception de mon site{' '}
          <a
            href="https://altcoach.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="testimonial-external-link"
          >
            www.altcoach.org
          </a>
          , il a su mettre son talent et sa passion au service de la vision que je porte. Fondateur de
          Wote, startup innovante dédiée à l&apos;accompagnement des étudiants et des entreprises dans
          leurs projets technologiques et académiques, Jonathan incarne l&apos;esprit
          d&apos;excellence et d&apos;innovation. Il met son expertise au service de la réussite
          académique et du progrès technologique, guidant Wote avec une vision claire et un engagement
          ferme. Son sens de l&apos;innovation, sa rigueur et sa générosité intellectuelle font de lui
          un bâtisseur d&apos;avenir. Jonathan ne se contente pas de créer des solutions : il inspire,
          il accompagne, il ouvre des chemins vers l&apos;excellence. Aujourd&apos;hui, je tiens à lui
          rendre un hommage vibrant et solennel. Merci, Jonathan, pour ton dévouement, ta créativité et
          ton engagement. Tu es non seulement un collaborateur précieux, mais aussi un véritable artisan
          de transformation et de progrès.
        </p>
      ),
      rating: 5,
      image: '/temoin3.jpg',
      isLong: true,
    },
  ];

  const current = testimonials[currentIndex];

  const isLongContent =
    current.isLong ||
    (typeof current.content === 'string' && current.content.length > LONG_TEXT_THRESHOLD);

  useEffect(() => {
    setIsExpanded(false);
  }, [currentIndex]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  const renderStars = (rating) => '⭐'.repeat(rating);

  const renderContent = () => {
    if (typeof current.content === 'string') {
      return (
        <p className="testimonial-text-block">
          &ldquo;{current.content}&rdquo;
        </p>
      );
    }
    return current.content;
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">
        <div className="testimonials-header">
          <h2 className="testimonials-title">Témoignages</h2>
          <p className="testimonials-subtitle">
            Découvrez ce que nos clients disent de nos services
          </p>
        </div>

        <div className="testimonials-slider">
          <button
            type="button"
            className="testimonial-nav-btn prev-btn"
            onClick={prevTestimonial}
            aria-label="Témoignage précédent"
          >
            ‹
          </button>

          <article className="testimonial-card">
            <div className="testimonial-image-card">
              <img src={current.image} alt={current.name} className="testimonial-image" />
            </div>

            <div className="testimonial-rating">{renderStars(current.rating)}</div>

            <div className="testimonial-content-block">
              <div
                className={`testimonial-content-inner ${
                  isLongContent && !isExpanded ? 'is-collapsed' : ''
                }`}
              >
                {renderContent()}
              </div>

              {isLongContent && (
                <button
                  type="button"
                  className="testimonial-read-more-btn"
                  onClick={() => setIsExpanded((prev) => !prev)}
                  aria-expanded={isExpanded}
                >
                  {isExpanded ? 'Lire moins' : 'Lire plus'}
                </button>
              )}
            </div>

            <footer className="testimonial-author">
              <h4 className="author-name">{current.name}</h4>
              <p className="author-role">{current.role}</p>
              <p className="author-project">{current.project}</p>
            </footer>
          </article>

          <button
            type="button"
            className="testimonial-nav-btn next-btn"
            onClick={nextTestimonial}
            aria-label="Témoignage suivant"
          >
            ›
          </button>
        </div>

        <div className="testimonials-indicators">
          {testimonials.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToTestimonial(index)}
              aria-label={`Aller au témoignage ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
